import { render, staticRenderFns } from "./ListMetalWithdraw.vue?vue&type=template&id=247c56d1&scoped=true"
import script from "./ListMetalWithdraw.vue?vue&type=script&lang=js"
export * from "./ListMetalWithdraw.vue?vue&type=script&lang=js"
import style0 from "./ListMetalWithdraw.vue?vue&type=style&index=0&id=247c56d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c56d1",
  null
  
)

export default component.exports